import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export const EditorField = ({ label, id, value, onChange, multiline, required = false, maxLength = 200, type = "text" }) => {
  const Component = multiline ? Textarea : Input;
  return <div className="min-w-0 space-y-2">
    <label htmlFor={id} className="block text-sm text-slate-300 font-medium">{label}</label>
    <Component id={id} data-testid={id} className="editor-control w-full" value={value ?? ""} required={required} maxLength={maxLength} type={type} rows={multiline ? 4 : undefined} onChange={(e) => onChange(e.target.value)} />
  </div>;
};